import team1 from "../../assets/our-team-1.jpg";
import team2 from "../../assets/our-team-2.jpg";
import team3 from "../../assets/our-team-3.jpg";
import team4 from "../../assets/our-team-4.jpg";
import team5 from "../../assets/our-team-5.jpg";
import team6 from "../../assets/our-team-6.jpg";

const TeamJsonData = {
  TeamNames: [
    {
      img: team1,
      name: "Petter Mokhtar",
    },
    {
      img: team2,
      name: "Frank Johnson",
    },
    {
      img: team3,
      name: "Joshua Stemple",
    },
    {
      img: team4,
      name: "Eliane Stclair",
    },
    {
      img: team5,
      name: "Amanda Mokhtar",
    },
    {
      img: team6,
      name: "John Stclair",
    },
  ],
};

export default TeamJsonData;
